import { render } from "./only-client.vue?vue&type=template&id=12ce12a0"
import script from "./only-client.vue?vue&type=script&lang=js"
export * from "./only-client.vue?vue&type=script&lang=js"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/only-client.vue'],['render',render],['__file',"only-client.vue"]])

export default __exports__